import { render, staticRenderFns } from "./PaywallGlyph.vue?vue&type=template&id=59c1390c&"
import script from "./PaywallGlyph.vue?vue&type=script&lang=js&"
export * from "./PaywallGlyph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports